<template>
  <div class="integral-rule app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>操作名称</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入操作名称" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>周期范围</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.range" class="app-block" placeholder="请选择周期范围">
              <a-select-option :value="1">{{integralStatusText(1)}}</a-select-option>
              <a-select-option :value="2">{{integralStatusText(2)}}</a-select-option>
              <a-select-option :value="3">{{integralStatusText(3)}}</a-select-option>
              <a-select-option :value="4">{{integralStatusText(4)}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>状态</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.status" class="app-block" placeholder="请选择状态">
              <a-select-option :value="1">启用</a-select-option>
              <a-select-option :value="0">禁用</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="state" slot-scope="text, data">
        <a-switch :checked="data.state === 1" :loading="data.stateLoading" @click="stateChange(data)"></a-switch>
      </template>
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="editIntegralRule(data)">编辑</a-button>
        </a-space>
      </template>
    </a-table>
    <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmModal" destroy-on-close>
      <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
        <a-form-model-item label="周期范围" prop="range">
          <a-select v-model="form.range" class="app-block" placeholder="请选择周期范围">
            <a-select-option :value="1" v-if="modal.id !== 6 && modal.id !== 7 && modal.id !== 8 && modal.id !== 12">{{integralStatusText(1)}}</a-select-option>
            <a-select-option :value="2" v-if="modal.id !== 2 && modal.id !== 6 && modal.id !== 7 && modal.id !== 8 && modal.id !== 12">{{integralStatusText(2)}}</a-select-option>
            <a-select-option :value="3" v-if="modal.id !== 2 && modal.id !== 6 && modal.id !== 7 && modal.id !== 8">{{integralStatusText(3)}}</a-select-option>
            <a-select-option :value="4" v-if="modal.id !== 2 && modal.id !== 12">{{integralStatusText(4)}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="奖励限制状态" prop="status">
          <a-radio-group v-model="form.status">
            <a-radio :value="1">限制</a-radio>
            <a-radio :value="0">不限制</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="奖励限制次数" prop="count" v-if="form.status === 1">
          <a-input-number v-model="form.count" placeholder="请输入奖励限制次数" :min="1" allow-clear></a-input-number>
        </a-form-model-item>
        <a-form-model-item label="奖励积分" prop="score">
          <a-input-number v-model="form.score" placeholder="请输入奖励积分" :min="0" allow-clear></a-input-number>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import {
    integralStatusText
  } from '@/io/dict.js';
  import IntegralRuleService from '@/io/integral_rule.js';

  export default {
    name: 'IntegralLog',
    data() {
      let self = this;
      return {
        integralStatusText,
        table: {
          loading: false,
          search: {
            name: null,
            range: [],
            status: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '操作事件',
              dataIndex: 'name'
            },
            {
              title: '周期范围',
              dataIndex: 'rangeText'
            },
            {
              title: '奖励上限次数',
              dataIndex: 'max_astrict'
            },
            {
              title: '奖励积分',
              dataIndex: 'score'
            },
            {
              title: '状态',
              scopedSlots: { customRender: 'state' }
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        form: {
          range: [],
          status: null,
          count: 1,
          score: 0
        },
        rules: {
          range: [
            {
              required: true,
              message: '请选择周期范围'
            }
          ],
          status: [
            {
              required: true,
              message: '请选择奖励上限状态'
            }
          ],
          count: [
            {
              required: true,
              message: '请输入奖励上限次数'
            }
          ],
          score: [
            {
              required: true,
              message: '请输入奖励积分'
            }
          ]
        },
        modal: {
          id: null,
          title: null,
          show: false,
          loading: false
        }
      }
    },
    activated() {
      this.initData();
    },
    methods: {
      editIntegralRule(data) {
        this.modal.id = data.id;
        this.modal.title = `调整${data.name}积分规则`;
        this.form.range = data.range;
        this.form.status = typeof data.max_astrict === 'number' ? 1 : 0;
        this.form.count = typeof data.max_astrict === 'number' ? data.max_astrict : 1;
        this.form.score = data.score;
        this.modal.show = true;
      },
      stateChange(data) {
        let checked = data.state === 1;
        data.stateLoading = true;
        IntegralRuleService[checked ? 'disable' : 'enable'](data.id).then(res => {}).catch(err => {}).finally(() => {
          this.$afterFormSubmit(checked ? '关闭成功' : '开启成功');
          data.state = checked ? 0 : 1;
          data.stateLoading = false;
        });
      },
      confirmModal() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          this.modal.loading = true;
          IntegralRuleService.edit(
            this.modal.id,
            this.form.range,
            this.form.status ? this.form.count : null,
            this.form.score
          ).then(res => {
            this.$afterFormSubmit('编辑成功', () => {
              this.initData();
            });
          }).catch(err => {}).finally(() => {
            this.modal.show = false;
            this.modal.loading = false;
          });
        });
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          name: null,
          date: [],
          type: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        return IntegralRuleService.listPage(
          this.table.search.name,
          this.table.search.range,
          this.table.search.status,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.stateLoading = false;
            val.range = val.cycle;
            val.rangeText = integralStatusText(val.cycle);
            val.max_astrict = val.max_astrict || '不限制次数';
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      },
    },
  }
</script>

<style lang="less" scoped>

</style>